import React from 'react'
import Box from '../components/Box'

export default function Section17() {
    return (
        <div className="section">
            <h2>Appendix A: Data Management</h2>
            <p>There are two primary methods of transferring data out of GradeBook Pro, report exporting and archiving. This section will explain the proper use of each function.</p>

            <Box title={'Report Export'} body={`The data export functions are used to transfer data out of GradeBook Pro for use in another
        application. The data is exported as a comma separated value (CSV) file. Most spreadsheet
        applications can import CSV files. After importing the file into a spreadsheet application you can
        manipulate or print the data.
        Data can be exported with the class, student, and assignment report generators on the “Data” screen.
        Benefits:
        • Exported data can be opened in multiple applications; GradeBook Pro is not required.
        • The data can be manipulated to perform additional analysis.
        • Data can be manipulated into a form required for reporting or archiving.
        Drawbacks:
        • Once the data is exported it cannot be imported back into GradeBook Pro. Exporting data does
        not suffice as a backup method because if your database becomes inaccessible for any
        reason the data cannot be recovered from the CSV files.
        • Not all data is included in the export.`} />

        <div className="box-container">
            <div className="heading">Archive</div>
            <div className="body">
                <p>All of the data entered into GradeBook Pro is stored in a SQLite database. If you want to create a full backup of your data this file must be archived. It is a good idea to do this regularly, especially if you do not regularly sync with iTunes. Similar to the data export there are three ways to achieve this.</p>
                <p>1. In the “Data” screen, tap the “Email Database File” button to attach the database file to an email message. You can send this message to any email address. Note that some email servers will reject the attachments (the database file can be large, especially if a lot of photos have been selected). If you receive a warning or empty message use an alternate method to retrieve the file.</p>
                <p>2. Use iTunes File Sharing (see Section X) to retrieve the GradeBookPro.sqlite file (not the GradeBookPro~.sqlite file, this is a temporary file).</p>
                <p>3. Upload the data to Dropbox. Tap “Database Backup” in the Dropbox section of the “Data” screen.</p>
                <br/>
                <p>Benefits:</p>
                <div>
                    <p>• All data is backed up. The data can be transferred to a new device or restored in the event of a data loss.</p>
                </div>
                <p>Drawbacks:</p>
                <div>
                    <p>• The data can only be read by GradeBook Pro. You cannot open this file on your desktop PC, only archive it.</p>
                </div>
            </div>
        </div>


                <div className="box-container">
                    <div className="heading">iTunes and iCloud Backup & Restore</div>
                    <div className="body">
                        <p>When you sync your iOS Device to iTunes a backup of your data is created. If you experience a data loss and do not have a recent archived copy of your database file you can restore the iOS Device from the backup and the app data will be restored to the point of the last sync.</p>
                        <p>This requires restoring the entire iOS Device to a previous state and will impact all of your apps, not just GradeBook Pro. iTunes only maintains the latest backup so if you are going to rely solely on this backup method these limitations should be kept in mind.</p>
                    </div>
                </div>

                <div className="box-container">
                    <div className="heading">Recommended Backup Plan</div>
                    <div className="body">
                        <p>Archive your database file periodically. If your file is small enough to be sent via email or Dropbox this is  preferable,  as  it  will  maintain  an  additional  copy  of  your  database  file  on  a  separate  server.  It  is especially important to archive this file before installing an app upgrade or making major changes to your data structure.</p>
                        <p>Perform  an  export  at  the  end  of  the  term  to  maintain  files  in  your  records  that  are  not  proprietary  to GradeBook  Pro.  These  files  can  also  be  manipulated  into  any  format  necessary  for  reporting purposes.</p>
                        <p>Backup to iTunes or iCloud regularly.</p>
                    </div>
                </div>

            <Box title={'Security:'} body={`Data is stored in an unencrypted SQLite database file. 
No encryption is used when emailing export files. 
Dropbox security is managed by the official Dropbox SDK used for development. 
Third party document provider security is managed by the third party.`} />



            <Box sectionData={'end'} title={'Moving Data to a New Device'} body={`All of the app data is retained the database file.  Performing a backup on the old device and a restore 
on the new device is sufficient for moving all app data (except settings). The Save Database File and 
Open Database File functions on the Data screen are also helpful.`} />
        </div>
    )
}
